export default __webpack_public_path__ + "static/media/calendar_white.b10df47e.svg";